<template>
    <b-container class="terms" fluid>
        <b-row>
            <b-col class="module">
                <ModuleTitle :caption="terms.title"></ModuleTitle>
            </b-col>
        </b-row>
        <b-row class="list-item">
            <b-col class="module" v-html="terms.content">

            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import ModuleTitle from '../components/common/ModuleTitle'

    import {mapState, mapActions} from 'vuex'

    export default {
        name: 'terms',
        components: {
            ModuleTitle,
        },
        computed: {
            ...mapState('terms', {
                terms: ({terms}) => {
                    return {
                        title: terms.title,
                        content: terms.content,
                    }
                },

            })
        },
        methods: {
            ...mapActions('terms', ['getPageInfo'])
        },
        created() {
            this.getPageInfo()
        }
    }
</script>

<style lang="less" scoped>
    @import "../assets/style/var";

    .en {
        h1 {
            font-family: Montserrat-Medium, Helvetica, Arial, sans-serif !important;
        }

        h3,h6 {
            font-family: Montserrat-Medium, Helvetica, Arial, sans-serif !important;
        }
    }

    .terms {
        padding: 0 150px;

        .list-item {
            .col {
                &:nth-child(n+4) {
                    margin-top: 100px;
                }
            }
        }

        .module {
            text-align: left;

            /deep/ .title {
                padding-top: 192px !important;
                padding-bottom: 52px !important;
            }
        }

        .card {
            border: none;

            .card-body {
                padding: 0;
                text-align: left;

                .card-title {
                    margin-bottom: 20px;
                    font-size: 20px;
                    line-height: 28px;
                    font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif !important;
                }

                .card-text {
                    font-size: 14px;
                    line-height: 28px;
                    margin-bottom: 0 !important;
                    transition: color .3s;
                    cursor: pointer;
                    &:hover {
                        color: #666;
                    }
                }
            }
        }

        .contact {
            .title {
                margin: 121px auto 50px auto;
                text-align: center;
                font-size: 18px;
                line-height: 27px;
            }

            .btn-container {
                text-align: center;
                .btn {
                    width: 400px;
                    font-size: 18px;
                    line-height: 27px;
                }
            }
        }
    }
</style>
